<template>
    <IOContainer :maxHeight="maxHeight" class="text-body-1 typography1--text">
        <div v-if="containsFiles">
            <v-simple-table v-if="!loading">
                <thead>
                    <tr>
                        <th class="text-left">Output</th>
                        <th class="text-left">File Name</th>
                        <th class="text-right">Size</th>
                        <th class="text-center">Download</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="output in outputs" :key="output.name">
                        <td class="text-left">{{ output.name }}</td>
                        <td class="text-left">{{ output.fileName }}</td>
                        <td class="text-right">{{ output.size }}</td>
                        <td class="text-center">
                            <v-btn
                                text
                                @click="
                                    downloadFile(
                                        output.downloadUrl,
                                        output.fileName
                                    )
                                "
                            >
                                <v-icon> mdi-download </v-icon>
                            </v-btn>
                        </td>
                    </tr>
                </tbody>
            </v-simple-table>
            <div v-else>loading...</div>
        </div>
        <div v-else>No file outputs</div>
    </IOContainer>
</template>
<script>
import IOContainer from '../shared/IOContainer.vue'
import { mapActions } from 'vuex'

export default {
    components: { IOContainer },
    props: ['record', 'maxHeight'],
    data() {
        return {
            loading: true,
            outputs: [],
        }
    },
    watch: {
        record: {
            handler: async function () {
                this.loading = true
                await this.setOutputs()
            },
            deep: true,
        },
    },
    computed: {
        containsFiles() {
            return (
                (this.record.output.result &&
                    this.record.calc.hasFileOutputs) ||
                this.record.output.arupComputeResultFileItems
            )
        },
    },
    methods: {
        ...mapActions(['getBlobSize']),
        async setOutputs() {
            if (this.record.output.result && this.record.calc.hasFileOutputs) {
                this.outputs = [
                    await this.pullInfoFromUrl(
                        this.record.output.result,
                        'Default'
                    ),
                ]
                this.loading = false
                return
            }
            if (this.record.output.arupComputeResultFileItems) {
                this.outputs = await Promise.all(
                    this.record.output.arupComputeResultFileItems.map((item) =>
                        this.pullInfoFromUrl(item.fileLink, item.description)
                    )
                )
                this.loading = false
                return
            }

            this.loading = false
        },
        async pullInfoFromUrl(url, outputName) {
            const pathSplit = new URL(url).pathname.split('/')
            const fileSizeBytes = await this.getBlobSize({
                blobUrl: url,
            })
            return {
                name: outputName,
                fileName: pathSplit[pathSplit.length - 1].replaceAll(
                    '%20',
                    ' '
                ),
                size: this.humanFileSize(fileSizeBytes),
                downloadUrl: url,
            }
        },
        downloadFile(uri, name) {
            let link = document.createElement('a')
            link.download = name
            link.href = uri
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        },
        /**
         * Format bytes as human-readable text. Source: https://stackoverflow.com/questions/10420352/converting-file-size-in-bytes-to-human-readable-string
         *
         * @param bytes Number of bytes.
         * @param si True to use metric (SI) units, aka powers of 1000. False to use
         *           binary (IEC), aka powers of 1024.
         * @param dp Number of decimal places to display.
         *
         * @return Formatted string.
         */
        humanFileSize(bytes, si = false, dp = 1) {
            const thresh = si ? 1000 : 1024

            if (Math.abs(bytes) < thresh) {
                return bytes + ' B'
            }

            const units = si
                ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
                : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
            let u = -1
            const r = 10 ** dp

            do {
                bytes /= thresh
                ++u
            } while (
                Math.round(Math.abs(bytes) * r) / r >= thresh &&
                u < units.length - 1
            )

            return bytes.toFixed(dp) + ' ' + units[u]
        },
    },
    async mounted() {
        await this.setOutputs()
    },
}
</script>
